import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import template from '../../templates/NewScope/NewScopeCategory.rt';

import {
  deleteQtCategory, postQtCategory, toggleQtCategoryImagePopup, setQtCategories, setActiveQtCategoryIndex
} from "./newScopeActions";

import NewScopeCategoryInterface from "./newScopeCategoryInterface";
import {getCategoryIconStyles} from "../../utilities/iconSizes";

class NewScopeCategory extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      isDraggedOver: false
    };
  }

  static propTypes = {
    qtCategory: NewScopeCategoryInterface.isRequired,
    qtCategoryIndex: PropTypes.number.isRequired
  };

  setQtCategoryActive = (event) => {
    // console.log(this.props.qtCategory);
    const excludedClassNames = ["ui-svg-checkbox", "ui-icon-remove2", "ui-icon-edit", "ui-input", "ui-button--add2"];
    if (!excludedClassNames.some(className => {
      return event.target.classList.contains(className) || event.target.closest("."+className)
    })) {
      this.props.setActiveQtCategoryIndex(this.props.qtCategoryIndex);
    }
  };

  deleteQtCategory = () => {
    this.props.deleteQtCategory(this.props.qtCategory.id);
  };

  editQtCategory = () => {
    this.props.setQtCategories(this.props.qtCategories.map(cat => {
      if (cat.id === this.props.qtCategory.id) {
        cat.editing = !cat.editing
      }
      return cat
    }));
  };

  categoryCheckboxClick = () => {
    const qtCategory = this.props.qtCategory;
    qtCategory.enabled = !qtCategory.enabled;
    this.props.postQtCategory(qtCategory, true);
  };

  editQtCategoryImage = () => {
    this.props.toggleQtCategoryImagePopup(this.props.qtCategoryIndex)
  };

  categoryNameChange = (newValue) => {
    const qtCategory = this.props.qtCategory;
    if (qtCategory.name !== newValue) {
      qtCategory.editing = false;
      qtCategory.name = newValue;
      this.props.postQtCategory(qtCategory, true);
    } else {
      this.props.setQtCategories(this.props.qtCategories.map(cat => {
        if (cat.id === this.props.qtCategory.id) {
          cat.editing = false;
        }
        return cat
      }));
    }
  };

  onMouseOver = () => {
    // if group is dragged && cat name !== All
    if (window.draggingFeatureGroup && this.props.qtCategoryIndex) {
      this.setState({
        isDraggedOver: true
      })
    }
  };

  onMouseLeave = () => {
    if (this.state.isDraggedOver) {
      this.setState({
        isDraggedOver: false
      })
    }
  };

  getImageStyle = (bgImageUrl) => {
    return getCategoryIconStyles(bgImageUrl);
  };

  render() {
    return template.call(this)
  }
}

const mapStateToProps = (store) => {
  return {
    qtCategories: store.newScope.qtCategories,
    qtCategoryImageEditIndex: store.newScope.qtCategoryImageEditIndex,
    activeQtCategoryIndex: store.newScope.activeQtCategoryIndex,
  };
};

export default connect(mapStateToProps, {
  postQtCategory,
  deleteQtCategory,
  toggleQtCategoryImagePopup,
  setQtCategories,
  setActiveQtCategoryIndex
})(NewScopeCategory);
